import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComponentUtilsService } from '@core/services';
import {
  biometricValidationMethod,
  customComponentListener,
} from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { IconsComponent } from '@shared/components/icons/icon.component';
import {
  biometricValidationFaceSvgIcon,
  biometricValidationFingerprintSvgIcon,
} from 'src/assets/icons/icons';

@Component({
  imports: [TranslateModule, IconsComponent],
  standalone: true,
  selector: 'biometric-validation-method-selection-component',
  templateUrl: './validation-method-selection.component.html',
  styleUrls: ['./validation-method-selection.component.scss'],
})
export class CustomBiometricValidationMethodSelectionComponent {
  @Input({ required: false }) listeners!: customComponentListener[];

  @Output() onBiometricValidationMethodSelected = new EventEmitter<{
    method: biometricValidationMethod;
  }>();

  protected selectedValidationMethod?: biometricValidationMethod = undefined;

  protected configOptions: {
    id: biometricValidationMethod;
    label: string;
    icon: string;
  }[] = [
    {
      id: 'face',
      label: 'app.pageId.biometric.validation-method-selection.face-validation',
      icon: biometricValidationFaceSvgIcon,
    },
    {
      id: 'fingerprint',
      label:
        'app.pageId.biometric.validation-method-selection.fingerprint-validation',
      icon: biometricValidationFingerprintSvgIcon,
    },
  ];

  constructor(private utils: ComponentUtilsService) {}

  ngOnInit() {
    this.utils.attachListeners(this, this.listeners);
  }

  setBiometricValidationMethod(method: biometricValidationMethod) {
    this.selectedValidationMethod = method;
    this.onBiometricValidationMethodSelected.emit({
      method: method,
    });
  }
}
